var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',[_c('div',{attrs:{"className":"workOrder_info"}},[_c('div',{attrs:{"className":"common_title"}},[_vm._v(" 功能未开通，联系程经理:18015525715 ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }